<template>
  <div class="mb-4">
    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="candidatos"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    >
    </fccTable>

    <div class="d-flex flex-row-reverse">
      <fccButton @click="excluir">Excluir</fccButton>
      <fccButton @click="atualizar" class="mr-2">Atualizar</fccButton>
    </div>
  </div>
</template>
<script>
export default {
  props: ['candidatos'],
  data() {
    return {
      dadosSelecionados: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'cidade', label: 'Cidade de Provas', sortable: true },
        { key: 'colegio', label: 'Colégio Atual', sortable: true },
        { key: 'salaatual', label: 'Sala Atual', sortable: true },
        { key: 'opcao', label: 'Opção', sortable: true },
        { key: 'inscricao', label: 'Inscrição', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'cpf', label: 'CPF', sortable: true },
        { key: 'num_pedido', label: 'Nº do Pedido', sortable: true }
      ],
      itemsPorPage: 10
    }
  },
  computed: {
    possuiLinhaSelecionada() {
      return this.dadosSelecionados.length > 0
    }
  },
  methods: {
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    atualizar() {
      const payload = this.dadosSelecionados.map((candidato) => {
        return {
          idDataCandidato: candidato.iddatacandidato,
          codVirtual: candidato.colegiocadastro,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      this.$emit('atualizar', payload)
    },
    excluir() {
      const payload = this.dadosSelecionados.map((candidato) => {
        return {
          idDataCandidato: candidato.iddatacandidato,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      this.$emit('excluir', payload)
    }
  }
}
</script>